import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import * as css from "./Card.module.css"

function Card({
  children,
  className,
  color,
  padding,
  noPadding,
  full,
  href,
  ...rest
}) {
  const classNames = cx(css.root, className, {
    [css.colorAzure]: color === "azure",
    [css.colorCove]: color === "cove",
    [css.noPadding]: !!noPadding,
    [css.paddingMedium]: padding === "medium",
    [css.full]: !!full,
  })

  if (href) {
    return (
      <a href={href} className={classNames} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(["azure", "cove"]),
  padding: PropTypes.oneOf(["medium"]),
  noPadding: PropTypes.bool,
  full: PropTypes.bool,
  href: PropTypes.string,
}

export default Card
